import { Contact } from 'src/presentation/pages'

export const makeContact = () => <Contact />
